import slice from "./competitionNewSlice";

export default slice.reducer;
